import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

import { Group } from '../models/group';
import { Plant } from '../models/plant';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})

export class CilConfigurationService {
  /**
   * Client-side cap for CIL/GetCILData.
   * The API runs CIL_SP_GUID_Task with SqlCommand.CommandTimeout = 1000s (~16 min),
   * and Angular sets no HTTP timeout, so a blocked stored procedure leaves the
   * request 'pending' indefinitely and the grid spinner never stops. Fail fast
   * instead, so the user gets an error they can act on.
   */
  private static readonly GET_CIL_DATA_TIMEOUT_MS = 100000;

  get o3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  // hardCodeToken: string = environment.token;

  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    //const token = this.hardCodeToken ;//localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'Common/GetGroup', data, { headers: header });
  }

  GetPlantByEgDDL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<any[]>(this.o3CoreApiUrl + 'DMS/GetPlantByEgDDL', { headers: header, params: { Id: data.Id } });
  }

  async GetCILData(data: any): Promise<any> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return await this.http
      .post<any>(this.o3CoreApiUrl + 'CIL/GetCILData', data, { headers: header })
      .pipe(timeout(CilConfigurationService.GET_CIL_DATA_TIMEOUT_MS))
      .toPromise();
  }
  GetCILDataForSFDC(data:any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetCILData', data, {headers: header} );
  }
  GetTreeModal(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'Common/GetTreeModal', data, { headers: header });
  }

  GetCompModelTreeForCIL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetCompModelTreeForCIL', data, { headers: header });
  }

  GetMachineModelTreeForCIL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetMachineModelTreeForCIL', data, { headers: header });
  }

  PerformCilTask(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/InsertCILTransaction', data, { headers: header });
  }

  performCilAction(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/InsertCILTransactionMultiple', data, { headers: header });
  }
  getLineList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetLineList', data);
  }
  getUnitList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetUnitList', data);
  }
  getAssemblyList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetAssemblyList', data);
  }
  getComponentListByAssembly(data: any): Observable<any> {
    return this.http.post<any>(this.o3CoreApiUrl + 'CIL/GetComponentListByAssembly', data);
  }
  getTaskAssignedUsers(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetTaskAssignedUsers', data);
  }
}
